export default __webpack_public_path__ + "static/b2b-3b7ebf5d8fe795fec5b9cfe69201f033.jpg";